import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {NavigationService} from "../../services/navigation.service";


@Component({
	selector: 'app-ask-to-create-account-modal',
	templateUrl: './ask-to-create-account-modal.component.html',
	styleUrls: ['./ask-to-create-account-modal.component.scss'],
})
export class AskToCreateAccountModalComponent implements OnInit {
	constructor(
		public modalCtrl: ModalController,
		private navSvc: NavigationService) { }

	static async show(modalCtrl: ModalController){
		const modal = await modalCtrl.create({
			cssClass: 'auto-height full-width',
			component: AskToCreateAccountModalComponent,
			componentProps: {},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}

	ngOnInit() {}
	dismiss() {
		this.modalCtrl.dismiss();
	}


	async login(){
		await this.modalCtrl.dismiss();
		this.navSvc.signIn();
	}

}
